module.exports = __webpack_public_path__ + "img/ceviche_de_pulpo.d3443934.jpg";